import Api from "./Api";
import Csrf from "./Csrf";

export default {
  async add(form) {
    await Csrf.getCookie();

    return Api.post("/daily-task-schedule", form);
  },

  async delete(id) {
    await Csrf.getCookie();

    return Api.delete("/daily-task-schedule/" + id);      
      
  },

 
};
